import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["actions", "bottomSpacing", "children"];
import React from 'react';
import Flex, { Box } from 'components/Flex';
var PanelHeader = function PanelHeader(_ref) {
  var actions = _ref.actions,
    _ref$bottomSpacing = _ref.bottomSpacing,
    bottomSpacing = _ref$bottomSpacing === void 0 ? 'xxs' : _ref$bottomSpacing,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Flex, _extends({
    mt: -6,
    mb: bottomSpacing,
    lineHeight: 1
  }, otherProps), /*#__PURE__*/React.createElement(Box, {
    shrink: true,
    overflow: "hidden"
  }, children), /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    borderBottom: "thin",
    ml: "xs"
  }), actions && /*#__PURE__*/React.createElement(Box, {
    mr: -6,
    pl: "xxs"
  }, actions));
};
export default PanelHeader;